import '../css/reset.scss';
import '../css/default.scss';
import '@babel/polyfill';

const MyApp=({ Component, pageProps })=> {
    return <Component {...pageProps} />
}
export default MyApp;